import React from 'react';
import { required, SelectInput } from 'react-admin';

export const TIME_ZONE_OPTIONS = [
  { id: 'America/New_York', name: 'America/New_York' },
  { id: 'America/Chicago', name: 'America/Chicago' },
  { id: 'America/Denver', name: 'America/Denver' },
  { id: 'America/Los_Angeles', name: 'America/Los_Angeles' },
];

export const TimeZoneInput = (isRequired) => (
  <SelectInput
    validate={isRequired ? [required()] : []}
    source="time_zone"
    choices={TIME_ZONE_OPTIONS}
  />
);
